import type { MaskitoOptions, MaskitoPreprocessor } from '@maskito/core';

export const phoneMask = {
    mask: [
        '+',
        '3',
        '8',
        '0',
        ' ',
        '(',
        /\d/,
        /\d/,
        ')',
        ' ',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
    ],
    preprocessors: [
        // ({ elementState, data }) => {
        //     const { value, selection } = elementState;

        //     return {
        //         elementState: {
        //             selection,
        //             value: value.replace(/\D/g, ''), // strip non-digits
        //         },
        //         data,
        //     };
        // },
    ],

    postprocessors: [
        // (elementStateAfterMask) => {
        //     const { value, selection } = elementStateAfterMask;
        //     // return an ElementState object (value + selection)
        //     return {
        //         value: value.replace(/\D/g, ''), // e.g. strip non-digits for model
        //         selection,
        //     };
        // },
    ],
} satisfies MaskitoOptions;

// Paste "89123456789" => "+7 (912) 345-67-89"
function createCompletePhoneInsertionPreprocessor(): MaskitoPreprocessor {
    const trimPrefix = (value: string): string => value.replace(/^(\+?7?\s?8?)\s?/, '');
    const countDigits = (value: string): number => value.replaceAll(/\D/g, '').length;

    return ({ elementState, data }) => {
        const { value, selection } = elementState;

        return {
            elementState: {
                selection,
                value: countDigits(value) > 11 ? trimPrefix(value) : value,
            },
            data: countDigits(data) >= 11 ? trimPrefix(data) : data,
        };
    };
}
